<template>
	<section id="intro" :class="color" class="main-content">
		<slot name="content">
			<div class="row">
				<div :class="color" class="columns column12 align-center">
					<span v-if="headingImage" />
					<h1 v-else>
						{{ title }}
					</h1>
					<div v-parse-links v-html="content" />
				</div>
			</div>
		</slot>
		<slot name="extraContent" />
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	color: { type: String, default: '' },
	content: { type: String, default: '' },
	headingImage: { type: Object, default: () => {} },
});
</script>

<style scoped>
@media (max-width: 960px) {
	.column6 {
		padding: 25px;
	}
}
</style>
